module.exports = __webpack_public_path__ + "img/fda.14281ad9.png";